export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Para que su tecnología de cámaras funcione de forma fiable a largo plazo',
      lead: 'SSG Care es nuestra suscripción de mantenimiento y soporte. Tras la instalación puede mantener su sistema con un contrato Care flexible, por una cuota mensual y con plazo acordado.',
    },
    abo: {
      title: 'Modelo de suscripción con plazo flexible',
      lead: 'La instalación se factura una vez. El soporte continuo funciona con suscripción mensual, cancelable o con plazo mínimo acordado.',
      items: {
        '0': { title: 'Soporte mensual', desc: 'Elija entre cancelación mensual o un plazo fijo (p. ej. 12 o 24 meses) con las condiciones correspondientes.' },
        '1': { title: 'Alcance individual', desc: 'No todo sistema necesita todo. Definimos juntos qué servicios entran en su contrato Care, de forma escalable y adaptable.' },
        '2': { title: 'Sin costes ocultos', desc: 'Cuota mensual transparente. Servicios adicionales fuera del contrato se acuerdan y facturan aparte.' },
      },
    },
    pricing: {
      eyebrow: 'Tarifas',
      title: 'Elija su tarifa Care',
      lead: 'Todos los precios son orientativos. La cuota final depende del tamaño de su sistema, el alcance y el plazo.',
      featured: 'Más popular',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Para sistemas pequeños', price: 'desde 19 €/mes', features: { '0': 'Revisión trimestral (remota)', '1': 'Gestión de actualizaciones de firmware', '2': 'Soporte de app por teléfono/email', '3': 'Solicitudes prioritarias' } },
        '1': { name: 'Care Professional', subtitle: 'Para sistemas comerciales', price: 'desde 39 €/mes', features: { '0': 'Revisión mensual (remota)', '1': 'Actualizaciones de firmware y parches', '2': 'Gestión de usuarios y derechos', '3': 'Control de almacenamiento y grabación', '4': 'Ayuda al cambiar de móvil', '5': 'Servicio in situ según acuerdo', '6': 'Atención prioritaria' } },
        '2': { name: 'Care Enterprise', subtitle: 'Para multisitios y grandes proyectos', price: 'Individual', features: { '0': 'Revisión semanal (remota)', '1': 'Todos los servicios Professional', '2': 'Contacto dedicado', '3': 'Consejos de ampliación proactivos', '4': 'Citas in situ regulares', '5': 'Documentación e informes' } },
      },
    },
    services: {
      title: 'Lo que SSG Care puede hacer por usted',
      items: {
        '0': { title: 'Revisiones periódicas', desc: 'Control de función, grabación y red, remoto o in situ según el plan.' },
        '1': { title: 'Actualizaciones de firmware', desc: 'Revisión y ejecución de actualizaciones acordadas según el fabricante.' },
        '2': { title: 'Soporte de app y acceso', desc: 'Ayuda con problemas de app, accesos y cambios de móvil o reinstalación.' },
        '3': { title: 'Gestión de usuarios y derechos', desc: 'Gestión de accesos, nuevos usuarios y cambios de permisos.' },
        '4': { title: 'Grabación y almacenamiento', desc: 'Control de ocupación, calidad de grabación y copias de seguridad.' },
        '5': { title: 'Soporte remoto', desc: 'Acceso remoto para diagnóstico y configuración, si es posible y lo desea.' },
      },
    },
    form: {
      title: 'Su oferta Care personal',
      lead: 'Cuéntenos qué soporte imagina. Le responderemos con una propuesta individual con plazo y cuota mensual.',
      customerType: 'Tipo de cliente',
      select: 'Seleccione',
      privat: 'Particular',
      gewerbe: 'Empresa',
      locations: 'Número de ubicaciones',
      locations1: '1 ubicación',
      locations2: '2–3 ubicaciones',
      locations3: '4 o más',
      cameraCount: 'Número aproximado de cámaras',
      cameras1: '1–2 cámaras',
      cameras2: '3–6 cámaras',
      cameras3: '7–12 cámaras',
      cameras4: '13 o más',
      systemStatus: 'Estado del sistema',
      statusNew: 'Sistema nuevo',
      statusExisting: 'Sistema existente',
      statusExtension: 'Ampliación prevista',
      contractTerm: 'Plazo de contrato deseado',
      termOpen: 'Abierto / por acuerdo',
      termMonthly: 'Cancelación mensual',
      term12: '12 meses',
      term24: '24 meses',
      term36: '36 meses',
      name: 'Nombre *',
      email: 'Email *',
      phone: 'Teléfono',
      company: 'Empresa',
      message: 'Información adicional',
      maxChars: 'Máximo 500 caracteres',
      consent: 'He leído la política de privacidad y acepto el tratamiento de mis datos para esta solicitud. *',
      success: 'Gracias por su solicitud. Le responderemos pronto con su oferta Care individual.',
      submit: 'Enviar solicitud Care',
      submitting: 'Enviando...',
    },
  },
};